import { readonly, ref } from 'vue'
import { getMe } from '@/services/backendService.js'

const currentUser = ref(null)
const isLoadingCurrentUser = ref(false)
const currentUserError = ref('')

export function useCurrentUser() {
  const refreshCurrentUser = async () => {
    isLoadingCurrentUser.value = true
    currentUserError.value = ''

    try {
      currentUser.value = await getMe()
      return currentUser.value
    } catch (error) {
      currentUserError.value = error instanceof Error ? error.message : String(error)
      throw error
    } finally {
      isLoadingCurrentUser.value = false
    }
  }

  return {
    currentUser: readonly(currentUser),
    currentUserError: readonly(currentUserError),
    isLoadingCurrentUser: readonly(isLoadingCurrentUser),
    refreshCurrentUser,
  }
}
